import { render, staticRenderFns } from "./RegraCoalesce.vue?vue&type=template&id=a0b4f70e&scoped=true"
import script from "./RegraCoalesce.vue?vue&type=script&lang=js"
export * from "./RegraCoalesce.vue?vue&type=script&lang=js"
import style0 from "./RegraCoalesce.vue?vue&type=style&index=0&id=a0b4f70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b4f70e",
  null
  
)

export default component.exports